module.exports = __webpack_public_path__ + "static/media/clue-1.f83c8594.svg";